import React, { useState } from "react";
import {
  CardBanner,
  CardBannerNumber,
  CardBannerIcon,
  CardBannerTitle,
  CardBannerWraper,
  CardBannerDivide,
} from "./styles";
import {
  BalanceIcon,
  EyeIcon,
  IconHideAmountNew,
  NoEyeIcon,
} from "../../pages/wallet-list/styles";
import { useApp } from "../../contexts";

export const CardSlideHeader = ({
  title,
  balance,
  period,
  type,
  active,
  onClick,
  colorPeriod,
  isMobile,
  infoIcon,
  bannerIcon
}) => {
  const [visible, setVisible] = useState(false);
  const { T } = useApp();
  return (
    <CardBannerWraper
      className={active && "active"}
      onClick={() => onClick?.()}
    >
      <CardBanner type={type}>
        <CardBannerIcon className="card-banner-icon">
          {bannerIcon}
        </CardBannerIcon>
        <CardBannerDivide className="card-banner-divide" />
        <div className="flex flex-col gap-0 lg:gap-2">
          <CardBannerTitle className="w-[125px] lg:w-auto flex items-center gap-2 card-banner-title">
            {T(title)} {infoIcon}
          </CardBannerTitle>

          <CardBannerNumber className="flex items-center card-banner-balance">
            {!visible ? (
              <IconHideAmountNew width={isMobile ? 80 : 150} />
            ) : (
              balance
            )}
            <BalanceIcon
              className="mb-1 card-banner-eye"
              onClick={(e) => {
                e.stopPropagation();
                setVisible(!visible);
              }}
            >
              {visible ? <EyeIcon /> : <NoEyeIcon />}
            </BalanceIcon>
          </CardBannerNumber>
        </div>
        {/* <CardBannerPeriod colorPeriod={colorPeriod} className="mt-[6px]">{period}</CardBannerPeriod> */}
      </CardBanner>
    </CardBannerWraper>
  );
};
